import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { ReactComponent as ICON_FULLSCREEN } from "@assets/svgs/ICON_FULLSCREEN.svg";
import { ReactComponent as ICON_TABLE_DELETE } from "@assets/svgs/ICON_TABLE_DELETE.svg";
import { ReactComponent as ICON_TABLE_EDIT } from "@assets/svgs/ICON_TABLE_EDIT.svg";
import { Icon } from "@components/Icon";
import { StyledInput } from "@components/Input";
import { Text } from "@components/Text";
import { COLOR_DARK, COLOR_WHITE } from "@static/COLORS";

const Container = styled.div`
  width: 100%;
  border-radius: 16px;
  background: ${COLOR_WHITE};
  padding: 1%;
  display: flex;
  flex-direction: row;
  gap: 18px;
`;

const SectionInput = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;
`;

const SectionAction = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

const ContainerVerticalField = styled.div`
  width: 100%;
`;

const InputGroup = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
`;

const ContainerHorizontalField = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const FIELD_LIST = ["name", "width", "height", "position_x", "position_y"];
const NUMERIC_FIELDS = ["width", "height", "position_x", "position_y"];

export const ImportAdsBlock = ({
  index,
  item,
  campaignWidth,
  campaignHeight,
  onHandleUpdateBlockInputValue = () => undefined,
  onHandleOpenModal = () => undefined,
  onHandleDeleteBlock = () => undefined,
  onHandleFullFrameBlock = () => undefined,
}) => {
  const onHandleChangeValue = ({ target }) => {
    const { name, value } = target;
    onHandleUpdateBlockInputValue({ index, name, value });
  };

  const onKeyPress = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <Container>
      <SectionInput>
        <ContainerVerticalField>
          <Text
            color={COLOR_DARK}
            fontWeight="500"
            fontSize="12px"
            style={{ marginBottom: 4, marginLeft: 4 }}
          >
            Name
          </Text>
          <StyledInput
            style={{ height: 24, fontSize: 12 }}
            name={"name"}
            size="large"
            value={_.get(item, ["name"])}
            onChange={({ target }) => onHandleChangeValue({ target })}
          />
        </ContainerVerticalField>

        <InputGroup>
          <ContainerHorizontalField>
            <Text color={COLOR_DARK} fontWeight="500" fontSize="12px">
              W
            </Text>
            <StyledInput
              style={{ height: 24, fontSize: 12 }}
              name={"width"}
              size="large"
              value={_.get(item, ["width"])}
              onKeyPress={onKeyPress}
              onChange={({ target }) => onHandleChangeValue({ target })}
            />
          </ContainerHorizontalField>
          <ContainerHorizontalField>
            <Text color={COLOR_DARK} fontWeight="500" fontSize="12px">
              H
            </Text>
            <StyledInput
              style={{ height: 24, fontSize: 12 }}
              name={"height"}
              size="large"
              value={_.get(item, ["height"])}
              onKeyPress={onKeyPress}
              onChange={({ target }) => onHandleChangeValue({ target })}
            />
          </ContainerHorizontalField>
        </InputGroup>
        <InputGroup>
          <ContainerHorizontalField>
            <Text color={COLOR_DARK} fontWeight="500" fontSize="12px">
              X
            </Text>
            <StyledInput
              style={{ height: 24, fontSize: 12 }}
              name={"position_x"}
              size="large"
              value={_.get(item, ["position_x"])}
              onKeyPress={onKeyPress}
              onChange={({ target }) => onHandleChangeValue({ target })}
            />
          </ContainerHorizontalField>
          <ContainerHorizontalField>
            <Text color={COLOR_DARK} fontWeight="500" fontSize="12px">
              Y
            </Text>
            <StyledInput
              style={{ height: 24, fontSize: 12 }}
              name={"position_y"}
              size="large"
              value={_.get(item, ["position_y"])}
              onKeyPress={onKeyPress}
              onChange={({ target }) => onHandleChangeValue({ target })}
            />
          </ContainerHorizontalField>
        </InputGroup>
      </SectionInput>
      <SectionAction>
        <Icon
          isCursor
          width={25}
          height={25}
          onClick={() => onHandleDeleteBlock(index)}
        >
          <ICON_TABLE_DELETE />
        </Icon>

        <Icon
          isCursor
          width={25}
          height={25}
          onClick={() => onHandleOpenModal({ item })}
        >
          <ICON_TABLE_EDIT />
        </Icon>
        <Icon
          isCursor
          width={17}
          height={17}
          onClick={() => onHandleFullFrameBlock({ index })}
        >
          <ICON_FULLSCREEN />
        </Icon>
      </SectionAction>
    </Container>
  );
};
